import {type ISavedCart} from '../schema';
import {savedCartIsEmpty} from './savedCartIsEmpty';

export const savedCartIsNotEmpty = (savedCart?: ISavedCart) =>
	!savedCartIsEmpty(savedCart);

export default savedCartIsNotEmpty;
